import React, { useEffect, useState, useRef } from 'react';
import classNames from 'classnames';
import Icon, {COLORS, ICONS} from './icon'
import TooltipWrapper from './tooltips/tooltip-wrapper';

export interface SlidingMenuOption { //returned in passed `callback` prop
	label: string,
	data?: any,
	disabled?: boolean;
	icon?: string
}

export interface Props {
	options: SlidingMenuOption[];
	selectedOption: SlidingMenuOption | null;
	callback: Function;
	className?: string;
	fullWidthDivider?: boolean;
	dividerClassname?: string;
}

export default function SlidingMenu(props: Props) {
	const {
		fullWidthDivider = false,
		options,
		selectedOption,
		callback,
		dividerClassname = ''
	} = props;

	const [underlineStyle, setUnderlineStyle] = useState({ width: 0, left: 0 });
	const wrapper = useRef<HTMLDivElement>(null);
	const underline = useRef<HTMLDivElement>(null);
	const optionsWrapper = useRef<HTMLDivElement>(null);

	useEffect(() => {
		if (!wrapper.current || !optionsWrapper.current) {
			return;
		}

		const selectedIndex = options.findIndex((option) => option.label === selectedOption?.label);
		const selectedElement = optionsWrapper.current.querySelector<HTMLElement>('.selected');

		if (![-1, 0].includes(selectedIndex)) {
			wrapper.current.classList.add('animate');
		}

		if (selectedElement) {
			setUnderlineStyle({
				width: selectedElement.offsetWidth ?? 0,
				left: selectedElement.offsetLeft ?? 0,
			});

			if (optionsWrapper.current.scrollWidth > wrapper.current.offsetWidth) {
				const selectedElWidth = (selectedElement.offsetLeft + (selectedElement.offsetWidth / 2) - wrapper.current.offsetWidth)
				const iconOffset = (selectedOption ?? options[0])?.icon ? 20 : 0;
				optionsWrapper.current.scroll({
					left: (selectedElWidth - iconOffset) + (wrapper.current.offsetWidth / 2)
					, top: underline.current?.offsetHeight
					, behavior: 'smooth',
				});
			}
		}

	}, [options, selectedOption, optionsWrapper.current?.offsetWidth]);

	return (
		<div className={classNames('sliding-menu-wrapper', 'width-calc-full', props.className)} ref={wrapper}>
			<div className='sliding-menu-options position-relative' ref={optionsWrapper}>
				{options.map((option: SlidingMenuOption, index: number) => {
					return (
						<div
							key={index}
							onClick={() => callback(option)}
							className={classNames(
								'sliding-menu-option',
								'font-weight-heavy',
								'white-space-nowrap',
								'padding-medium',
								option.disabled ? 'disabled' : '',
								{
									selected: selectedOption ? selectedOption.label === option.label : index === 0,
									'has-icon': option.icon && selectedOption?.label === option.label
								},
							)}
						>
							{!option.icon || selectedOption?.label === option.label ? <span className='text'>{option.label}</span> : null}
							
							{option.icon ? 	<TooltipWrapper message={option.label} position='below'>
								<div style={{paddingLeft: selectedOption?.label === option.label ? 0 : 0}}>
									<Icon name={option.icon} color={COLORS.WHITE} size={18}/>
								</div>
							</TooltipWrapper> : null}
						</div>
					);
				})}
				<div className={classNames('sliding-menu-underline position-absolute', `${dividerClassname}`)} style={underlineStyle} ref={underline}></div>
			</div>
			{fullWidthDivider && <div className='sliding-menu-divider' />}
		</div>
	);
}
